// Happens when the API throws an error
// fetch three times
import { ref } from '@vue/composition-api'

const isRefetchActivated = ref(false)

export default async function reFetchAPI(fn) {
  if (isRefetchActivated.value) return
  for (let i = 0; i < 3; i += 1) {
    isRefetchActivated.value = true
    // eslint-disable-next-line no-await-in-loop
    await fn()
  }
  isRefetchActivated.value = false
}
